import React, { useRef, useState, useEffect } from 'react';

import { useQuery } from 'react-query';

import { GetAllCareerPath } from 'services/core';

import CareerPathsWrapper from 'components/pages/explore/explorewrappernew/explorecareerpaths/careerpathswrapper/CareerPathsWrapper';
import LinkButton from '@core/components/linkbutton/LinkButton';

import classes from './ExploreCareerPaths.module.scss';

const ExploreCareerPaths = () => {
    const componentRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(entry.target);
                }
            },
            { threshold: 0 }
        );

        if (componentRef.current) {
            observer.observe(componentRef.current);
        }

        return () => observer.disconnect();
    }, []);
    const { data, isLoading } = useQuery(['career-paths-all'], GetAllCareerPath,
        {
            enabled: isVisible,
        }
    );
    return (
        <div ref={componentRef} className={`container  ${classes['wrapper']}`}>
            <div className='row d-flex align-items-start justify-content-center'>
                <div className="col-xxl-10 col-12">
                    {data && !isLoading && (
                        <CareerPathsWrapper careerPaths={data?.data} />
                    )}
                    <div className={`d-flex justify-content-center ${classes['link-wrapper']}`}>
                        <LinkButton to={'/career-path'} kind="secondary-lecture">
                            View All Career Paths
                        </LinkButton>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExploreCareerPaths;